import _capitalize from 'lodash/capitalize';
//
import React from 'react';

import type { LoadingButtonProps } from '@mui/lab/LoadingButton';
import LoadingButton from '@mui/lab/LoadingButton';

export type QButtonProps = LoadingButtonProps & {
  onClick?: (e?: any) => void;
};

/**
 * @deprecated QButtonNew is deprecated. Please use MUI Button or LoadingButton.
 */
const QButtonNew = React.forwardRef<any, QButtonProps>((props, ref) => {
  // eslint-disable-next-line react/prop-types
  const { children, onClick, ...other } = props;

  const transformedChildren = React.Children.map(children, (child: any) => {
    if (typeof child === 'string') {
      return _capitalize(child); // Transform text children
    }
    return child; // Return other components as-is
  });

  return (
    <LoadingButton onClick={onClick} ref={ref} {...other}>
      {transformedChildren}
    </LoadingButton>
  );
});

QButtonNew.displayName = 'QButtonNew';

export default QButtonNew;
